import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { MediaFieldDTO, MilestonesFieldUpdate } from '../../../../shared/Field/Field';
import { config } from '../../../core';

const baseQuery = fetchBaseQuery({
  baseUrl: new URL(`${config.api.prefix}process-fields`, config.api.origin).href,
  prepareHeaders: (headers) => {
    headers.set('Authorization', `Bearer ${localStorage.getItem('token') ?? sessionStorage.getItem('token')}`);
    return headers;
  },
});

enum EMilestonesFieldApiTagTypes {
  MILESTONES_FIELD = 'MILESTONES_FIELD',
}

// Define a service using a base URL and expected endpoints
export const milestonesFieldApi = createApi({
  reducerPath: 'MILESTONES_FIELD',
  baseQuery,
  tagTypes: [
    EMilestonesFieldApiTagTypes.MILESTONES_FIELD,
  ],
  endpoints: (builder) => ({
    getMilestonesFieldById: builder.query<MediaFieldDTO, { id: string, processId: string }>({
      query: ({ id, processId }) => `${processId}/milestones/${id}`,
      providesTags: (result, error, { id }) => [{ type: EMilestonesFieldApiTagTypes.MILESTONES_FIELD, id }],
    }),
    updateMilestonesFieldById: builder.mutation<MediaFieldDTO, MilestonesFieldUpdate>({
      query: (data: MilestonesFieldUpdate) => ({
        method: 'PATCH',
        url: `${data.processId}/milestones/${data.id}`,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: EMilestonesFieldApiTagTypes.MILESTONES_FIELD, id }],
    }),
    createMilestonesField: builder.mutation<MediaFieldDTO, MilestonesFieldUpdate>({
      query: (data: MilestonesFieldUpdate) => ({
        method: 'POST',
        url: `${data.processId}/milestones/${data.id}`,
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: EMilestonesFieldApiTagTypes.MILESTONES_FIELD, id }],
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateMilestonesFieldMutation,
  useGetMilestonesFieldByIdQuery,
  useUpdateMilestonesFieldByIdMutation,
} = milestonesFieldApi;
